import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogDatePipe } from './dialog-date.pipe';

@NgModule({
    declarations: [DialogDatePipe],
    imports: [CommonModule],
    exports: [DialogDatePipe],
})
export class DialogDateModule { }
